import { Component, OnInit } from "@angular/core";
import {
    ActivatedRoute,
    NavigationEnd,
    PRIMARY_OUTLET,
    Router,
} from "@angular/router";
import { filter } from "rxjs/operators";
import { BreadCrumb } from "../../models/common/bread-crumb";
import { BreadcrumbService } from "../../services/shared/breadcrumb-service";
import { UserService } from "../../services/user.service";

const ROUTE_DATA_BREADCRUMB: string = "title";

@Component({
    standalone: false,
    selector: "breadcrumbs",
    templateUrl: "./component.html",
})
export class BreadcrumbComponent implements OnInit {
    breadcrumbService: BreadcrumbService;
    private userService: UserService;
    private router: Router;
    private activatedRoute: ActivatedRoute;

    constructor(
        breadcrumbService: BreadcrumbService,
        router: Router,
        activatedRoute: ActivatedRoute,
        userService: UserService
    ) {
        this.breadcrumbService = breadcrumbService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.userService = userService;
    }

    ngOnInit() {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => {
                let root: ActivatedRoute = this.activatedRoute.root;
                this.breadcrumbService.breadcrumbs = this.getBreadcrumbs(root);
            });
    }

    private getBreadcrumbs(
        route: ActivatedRoute,
        url: string = "",
        breadcrumbs: BreadCrumb[] = []
    ): BreadCrumb[] {
        let children: ActivatedRoute[] = route.children;

        if (children.length === 0) {
            return breadcrumbs;
        }

        for (let child of children) {
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }

            if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
                return this.getBreadcrumbs(child, url, breadcrumbs);
            }

            let routeURL: string = child.snapshot.url
                .map((segment) => segment.path)
                .join("/");

            url += `/${routeURL}`;

            if (child.snapshot.data[ROUTE_DATA_BREADCRUMB]) {
                if (child.snapshot.data.baseUrl) {
                    if (url.startsWith("//"))
                        url = url.replace("/", child.snapshot.data.baseUrl);
                    else if (url === "/") url = child.snapshot.data.baseUrl;
                }

                let breadcrumb: BreadCrumb = {
                    name: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
                    params: child.snapshot.params,
                    path: url,
                    active: false,
                };

                breadcrumbs.push(breadcrumb);
            }

            return this.getBreadcrumbs(child, url, breadcrumbs);
        }
    }

    isUserLoggedIn() {
        return this.userService.isLoggedIn;
    }
}
